import ArticlesTab from "@features/creation/articles/components/ArticlesTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";

export const Route = createFileRoute("/_app/creation/articles/")({
  loader: requirePermission(PERMISSIONS.CREATION.ARTICLES.VIEW),
  staticData: {
    title: "Articles",
    icon: Sparkles,
    tab_icon: Sparkles,
    permission: PERMISSIONS.CREATION.ARTICLES.VIEW,
    module: "creation",
    section: "Creation",
    order: 21,
    description: "Gestion des articles",
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: ArticlesTab,
});
